import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "environment-variables"
    }}>{`Environment Variables`}</h1>
    <p>{`When an action is being executed, your code can use the following environment variables:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_ACTION_NAME`}</inlineCode>{` = the name of the action`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_ACTION_VERSION`}</inlineCode>{` = the internal revision of the action (developers cann't affect this)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_ACTIVATION_ID`}</inlineCode>{` = the activation ID`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_ALLOW_CONCURRENT`}</inlineCode>{` = indicates the runtime should support concurrency (should always be true for nodejs actions)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_API_HOST`}</inlineCode>{` = the host used for making additional OpenWhisk API requests within the action (e.g. using OpenWhisk JavaScript SDK)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_CLOUD`}</inlineCode>{` = AWS vs Azure`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_NAMESPACE`}</inlineCode>{` = the namespace of the invocation client`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_REGION`}</inlineCode>{` = AWS/Azure region where the action was executed`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`__OW_TRANSACTION_ID`}</inlineCode>{` = request ID sent with OW API request, or generated; see response header `}<inlineCode parentName="li">{`X-Request-Id`}</inlineCode></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      